/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export interface User {
  displayUid?: string;
  firstName?: string;
  lastName?: string;
  name?: string;
  uid?: string;
  customerId?: string;
}
